<template>
  <div id="floorplan-upload-wrapper" class="d-flex align-items-center justify-content-center">
    <!--    <label for="background" class="form-label">Uploadfloorplan</label>-->
    <!--    <input class=form-control type="file" id=background @change="handleFileChange">-->

    <div class="upload">
      <h3 class="title">{{ $t('admin.floorPlan.fileUpload.title') }}</h3>
      <p class="title-sub">{{ $t('admin.floorPlan.fileUpload.subTitle') }}</p>
<!--      <select v-model="department" name="" id="" class="form-control  rounded mb-5 ">-->
<!--        <option :value="null" disabled>{{ $t('topbar.selectDepartment') }}</option>-->
<!--        <option :key="department" v-for="department in departments" :value="department">-->
<!--          {{ department }}-->
<!--        </option>-->
<!--      </select>-->
      <VueFileAgent

          id="file-upload"
          ref="vueFileAgent"
          :theme="'list'"
          :multiple="false"
          :deletable="true"
          :meta="true"
          :accept="'image/jpg,image/jpeg,image/png'"
          :maxSize="allowedFileSize"
          :maxFiles="1 "
          :helpText="$t('dragAndDropContainer.helpText')"
          :errorText="{
            type: $t('admin.floorPlan.fileUpload.fileNotAllowed'),
            size: $t('dragAndDropContainer.errorText.size', { allowedFileSize }),
          }"
          @select="handleFileChange($event)"
          @beforedelete="onBeforeDelete($event)"
          @delete="fileDeleted($event)"
          v-model="file"
      >
        <template v-slot:file-preview>

          <!--          <div class="d-flex align-items-center justify-content-center  ">-->
          <!--            <div class="row" style="height:120px;background:white;">-->
          <!--              <div class="col-12 mt-5">-->
          <!--               <h4> {{ $t('admin.floorPlan.fileUpload.fileNotAllowed') }}</h4>-->
          <!--              </div>-->
          <!--&lt;!&ndash;              <div class="col-12 mt-3">&ndash;&gt;-->
          <!--&lt;!&ndash;                <p class="">{{$t('admin.floorPlan.fileUpload.helpText')}}</p>&ndash;&gt;-->
          <!--&lt;!&ndash;              </div>&ndash;&gt;-->
          <!--            </div>-->
          <!--          </div>-->
        </template>
        <template v-slot:file-preview-new>
          <div class="d-flex align-items-center justify-content-center upload-info" key="new">
            <div class="row">
              <div class="col-12">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" class="upload-icon"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M34 20H33.25C33.25 20.4142 33.5858 20.75 34 20.75V20ZM37.6245 34.3508C37.2659 34.5582 37.1434 35.017 37.3508 35.3755C37.5582 35.7341 38.017 35.8566 38.3755 35.6492L37.6245 34.3508ZM16.2478 21.105C16.6417 21.2333 17.0649 21.018 17.1932 20.6242C17.3215 20.2303 17.1063 19.8071 16.7124 19.6788L16.2478 21.105ZM9.62446 35.6492C9.983 35.8566 10.4418 35.7341 10.6492 35.3755C10.8566 35.017 10.7341 34.5582 10.3755 34.3508L9.62446 35.6492ZM24 24L24.5303 23.4697C24.2374 23.1768 23.7626 23.1768 23.4697 23.4697L24 24ZM23.25 42C23.25 42.4142 23.5858 42.75 24 42.75C24.4142 42.75 24.75 42.4142 24.75 42H23.25ZM29.4697 30.5303C29.7626 30.8232 30.2374 30.8232 30.5303 30.5303C30.8232 30.2374 30.8232 29.7626 30.5303 29.4697L29.4697 30.5303ZM17.4697 29.4697C17.1768 29.7626 17.1768 30.2374 17.4697 30.5303C17.7626 30.8232 18.2374 30.8232 18.5303 30.5303L17.4697 29.4697ZM14.75 18C14.75 12.8914 18.8914 8.75 24 8.75V7.25C18.0629 7.25 13.25 12.0629 13.25 18H14.75ZM24 8.75C29.1086 8.75 33.25 12.8914 33.25 18H34.75C34.75 12.0629 29.9371 7.25 24 7.25V8.75ZM33.25 18V20H34.75V18H33.25ZM13.25 18V20H14.75V18H13.25ZM34 20.75C38.0041 20.75 41.25 23.9959 41.25 28H42.75C42.75 23.1675 38.8325 19.25 34 19.25V20.75ZM41.25 28C41.25 30.6899 39.787 33.0998 37.6245 34.3508L38.3755 35.6492C40.9954 34.1337 42.75 31.2324 42.75 28H41.25ZM6.75 28C6.75 23.9959 9.99594 20.75 14 20.75V19.25C9.16751 19.25 5.25 23.1675 5.25 28H6.75ZM14 20.75C14.7858 20.75 15.5411 20.8748 16.2478 21.105L16.7124 19.6788C15.8575 19.4003 14.9456 19.25 14 19.25V20.75ZM10.3755 34.3508C8.21301 33.0998 6.75 30.6899 6.75 28H5.25C5.25 31.2324 7.00458 34.1337 9.62446 35.6492L10.3755 34.3508ZM23.25 24V42H24.75V24H23.25ZM30.5303 29.4697L24.5303 23.4697L23.4697 24.5303L29.4697 30.5303L30.5303 29.4697ZM23.4697 23.4697L17.4697 29.4697L18.5303 30.5303L24.5303 24.5303L23.4697 23.4697Z"
                      fill="#4F575E"/>
                </svg>
              </div>
              <div class="col-12 mt-3">
                <p class="">{{ $t('admin.floorPlan.fileUpload.helpText') }}</p>
              </div>
              <div class="col-12 mt-5 align-items-center justify-content-end">
                <button class="btn btn-cancel " @click="goBack()">{{ $t('ui.cancel') }}</button>
              </div>

            </div>


          </div>

        </template>


      </VueFileAgent>
    </div>
  </div>
</template>

<script>

export default {
  name: "FileUpload",
  components: {},
  props: ['departments'],
  data() {
    return {
      department: null,
      file: null,
      allowedFileSize: "20MB"
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    async handleFileChange(event) {
      const self = this
      let fileExtension = event[0].ext
      if (fileExtension == 'pdf') {
        this.file = []
        await this.$swal({
          icon: 'error',
          width: '50%',
          text: this.$root.$t('admin.floorPlan.fileUpload.pdfNotAllowed')
        })

      }
      let file = event[0].file
      self.$emit('fileChanged', file)
      const reader = new FileReader();
      this.$store.commit('setLoading',true)
      reader.onloadend = function (e) {
        self.$store.commit('setLoading',false)
        var image = new Image();
        image.src = e.target.result;
        self.$emit('changeStep', 2)

        image.onload = function () {
          var canvas = document.createElement('canvas');

          let svg = document.getElementById('svg-floormap')
          let {height, width} = svg.getBoundingClientRect()
          height = 720
          width= 1280
          canvas.width = width;
          canvas.height = height;

          canvas.getContext('2d').drawImage(image, 0, 0, width, height);
          var dataUrl = canvas.toDataURL('image/jpeg');
          canvas.toBlob((res) => {
            self.$emit('fileChanged', res)
          }, 'image/png', 1)

          self.$emit('imageData', dataUrl)
          self.file = []
        };
      }
      if (file) {
        reader.readAsDataURL(file);
      } else {
        // document.getElementById('floormap').setAttributeNS("http://www.w3.org/1999/xlink", "href", '')
        self.$emit('imageData', '')
        this.$emit('changeStep', 1)

      }
    },
    onBeforeDelete(fileRecord) {
      this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
    },
    fileDeleted(fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord);
      this.fileRecordsForUpload.splice(i, 1);
    },
  },
  watch: {
    department(newV) {
      this.$emit('departmentChanged', newV)
    }
  }
}
</script>

<style lang="scss">
#floorplan-upload-wrapper {
  height: 70vh;
  width: 100%;
  font-family: "Open Sans", sans-serif;

  h3 {
    color: #000000;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px;
    gap: 4px;

    /* Inside auto layout */

    flex: none;
    order: 0;
    flex-grow: 0;
  }

  p.title-sub {
    font-family: "Open Sans", sans-serif;

    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    /* identical to box height, or 20px */

    letter-spacing: 0.25px;

    /* Neutral Color / 700 */

    color: #6A7178;
    display: flex;
    flex-direction: column;
    align-items: center;


    order: 1;
    flex-grow: 0;
  }
}

.upload {
  height: 400px;
  width: 558px;
  left: 385px;
  top: 231px;
  border-radius: 8px;
  padding: 20px 32px 20px 32px;
  background: #F8F9FA;
}

#file-upload {
  height: 400px;
}


.vue-file-agent.file-input-wrapper {
  width: 494px;
  height: 133px;

  /* Neutral Color / 000 */
  background: #FFFFFF;
  /* Neutral Color / 700 */

  border: 1.5px dashed #6A7178;
  border-radius: 8px;
}

.theme-list .vue-file-agent .file-preview-wrapper .file-preview {
  height: 100%;
  padding: 0;
}

.theme-list .vue-file-agent .file-preview-new .help-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: black;
}

.file-preview-new {
  p {
    /* Body/Body XS/Bold */

    font-family: "Open Sans", sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 140%;
    /* identical to box height, or 17px */

    letter-spacing: 0.25px;

    /* Neutral Color / 900 */

    color: #272B30;


    /* Inside auto layout */

    flex: none;
    order: 1;
    flex-grow: 0;
  }
}

.upload-info {
  height: 230px;

}

.upload-icon {
  font-weight: 400;
  font-size: 50px
}

.btn-cancel {
  border: 1.5px solid #6A7178;
  border-radius: 4px;
  font-family: 'Open Sans', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
}
</style>